  let questionses = document.querySelectorAll(".questionses");
  questionses.forEach(questionses => {
    questionses.addEventListener("click", event => {
      const active = document.querySelector(".questionses.active");
      if (active && active !== questionses) {
        active.classList.toggle("active");
        active.nextElementSibling.style.maxHeight = 0;
      }
      questionses.classList.toggle("active");
      const answerses = questionses.nextElementSibling;
      if (questionses.classList.contains("active")) {
        answerses.style.maxHeight = answerses.scrollHeight + "px";
      } else {
        answerses.style.maxHeight = 0;
      }
    })
  })



    document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.querySelectorAll('.tab-content-block');

    if (!tabs.length) return;

    // Reset all tabs first (middle tabs)
    tabs.forEach(tab => {
      tab.style.marginTop = '0px';
      tab.style.marginBottom = '0px';
      tab.style.borderBottom = 'none'; // reset border
    });

    // First tab
    tabs[0].style.marginTop = '24px';
    tabs[0].style.marginBottom = '0px';

    // Last tab
    const lastTab = tabs[tabs.length - 1];
    lastTab.style.marginTop = '0px';
    lastTab.style.marginBottom = '24px';
    lastTab.style.borderBottom = '1px solid rgba(26, 26, 26, 0.12)';
  });



  new Swiper('.image-slider', {
     navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
     },
     breakpoints: {
      1200: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      989: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      }
    }
});

  

    const myDiv = document.getElementById('myDiv');
    const targetElement = document.getElementById('targetElement');
    let lastScroll = window.pageYOffset;
    let timeout;
    
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
    
      // check if target element has been scrolled past
      const targetRect = targetElement.getBoundingClientRect();
      if (targetRect.bottom <= 0) {
        myDiv.style.display = 'block'; // show sticky bar
        if (currentScroll > lastScroll) { // scrolling down
          myDiv.style.bottom = '-1px';
        } else { // scrolling up
          myDiv.style.bottom = '-175px';
        }
    
        lastScroll = currentScroll;
    
        clearTimeout(timeout); // clear previous timeout (if any)
        timeout = setTimeout(() => {
          myDiv.style.bottom = '-175px'; // hide element after 500ms of inactivity
        }, 5000);
      } else {
        myDiv.style.display = 'none'; // hide sticky bar
      }
    });